
import Assert from "tbAssert";

import ngSanitize from "angular-sanitize";
import ngAnimate from "angular-animate";
import ngAria from "angular-aria";
import uiBootstrap from "angular-ui-bootstrap";

import StatusClassServiceModule from "../../../services/StatusClassService";
import StatusLabelComponentModule from "../../../directives/StatusLabel";
import CalendarEventDateTimeComponentModule from "../../../directives/CalendarEventDateTime/CalendarEventDateTime";

const mStatusClassSvc = new WeakMap();

const mEventData = new WeakMap();
const mEditorNavigateFn = new WeakMap();
const mEventSelected = new WeakMap();

const mEventTrackers = new WeakMap();
const mEventParticipants = new WeakMap();
const mEventTypes = new WeakMap();

const mEventTextClass = new WeakMap();

const mEventTrackerNames = new WeakMap();
const mShowEventTrackerNames = new WeakMap();

const emptyEventData = {
    displayTitle: null,
    statusName: null,
    start: null,
    end: null,
    locationName: null,
    locationAddress: null,
    locationCity: null,
    locationStateName: null
};

class CalendarAgendaEventController {
    constructor(StatusClass) {
        Assert.StrictAssert(StatusClass != null, "Assertion Failure: Missing Status Class Service Dependency");

        mStatusClassSvc.set(this, StatusClass);

        mEventTrackerNames.set(this, null);
        mShowEventTrackerNames.set(this, false);

        // IMPORTANT: Directive binding setters run BEFORE the constructor or $onInit. So if you set a null value here,
        // it will OVERWRITE the value set by the component container.
    }

    get eventData() {
        return mEventData.get(this);
    }

    set eventData(updatedVal) {

        if (updatedVal != null) {
            mEventData.set(this, updatedVal);
            if (updatedVal.eventAttendees != null) {
                let eventParticipants = updatedVal.eventAttendees;
                mEventParticipants.set(this, eventParticipants);
            }
            else {
                mEventParticipants.set(this, []);
            }

            if (updatedVal.eventTrackers != null) {
                let eventTrackers = updatedVal.eventTrackers;
                mEventTrackers.set(this, eventTrackers);
            }
            else {
                mEventTrackers.set(this, []);
            }

            if (updatedVal.eventTypes != null) {
                let eventTypes = updatedVal.eventTypes;
                mEventTypes.set(this, eventTypes);
            }
            else {
                mEventTypes.set(this, []);
            }
        }
        else {
            mEventData.set(this, emptyEventData);
            mEventParticipants.set(this, []);
            mEventTrackers.set(this, []);
            mEventTypes.set(this, []);
        }
    }

    get editorNavigateFn() {
        return mEditorNavigateFn.get(this);
    }

    set editorNavigateFn(updatedVal) {
        mEditorNavigateFn.set(this, updatedVal);
    }

    get eventSelected() {
        return mEventSelected.get(this);
    }

    set eventSelected(updatedVal) {
        mEventSelected.set(this, updatedVal);
    }

    get eventDisplayTitle() {
        return mEventData.get(this).displayTitle;
    }

    get eventStatusName() {
        return mEventData.get(this).statusName;
    }

    get eventStatusClass() {
        return mStatusClassSvc.get(this)
            .getClassForStatus(mEventData.get(this).statusName);
    }

    get eventStart() {
        return mEventData.get(this).start;
    }

    get eventEnd() {
        return mEventData.get(this).end;
    }

    get eventLocationName() {
        return mEventData.get(this).locationName;
    }

    get eventLocationAddress() {
        return mEventData.get(this).locationAddress;
    }

    get eventLocationCity() {
        return mEventData.get(this).locationCity;
    }

    get eventLocationStateName() {
        return mEventData.get(this).locationStateName;
    }

    get eventEvtTypes() {
        return mEventTypes.get(this);
    }

    get eventParticipants() {
        return mEventParticipants.get(this);
    }

    get eventTrackers() {
        return mEventTrackers.get(this);
    }

    get eventTextClass() {
        return mEventTextClass.get(this);
    }

    set eventTextClass(updatedVal) {
        mEventTextClass.set(this, updatedVal);
    }

    get eventTrackerNames() {
        return mEventTrackerNames.get(this);
    }

    get showEventTrackerNames() {
        return mShowEventTrackerNames.get(this);
    }

    showEventDetails(e) {
        if (e != null) {
            e.preventDefault();
        }

        let currentEvent = this.eventData;
        this.eventSelected({evt: currentEvent});
    }

    toggleTrackerNames() {

        if (!this.showEventTrackerNames) {
            if (this.eventTrackerNames == null) {
                mEventTrackerNames.set(this, this.eventTrackers.map((trk) => trk.displayName).join(", "));
            }

            mShowEventTrackerNames.set(this, true);
        }
        else {
            mShowEventTrackerNames.set(this, false);
        }

    }
}

CalendarAgendaEventController.$inject = [ "StatusClass" ];

CalendarAgendaEventController.dependencies = [
    ngSanitize,
    ngAnimate,
    ngAria,
    uiBootstrap,
    StatusClassServiceModule,
    StatusLabelComponentModule,
    CalendarEventDateTimeComponentModule
];

CalendarAgendaEventController.template = require("./CalendarAgendaEvent.tpl.html");

CalendarAgendaEventController.controllerAs = "calendarEvent";

export default CalendarAgendaEventController;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-calendar-view/calendar-event/CalendarAgendaEventController.js
// module id = 3v9k
// module chunks = 1